@if (incomeTaxEntity$ | async) {
  <form [formGroup]="formGroup">
    @if (kostenExtraGezinshulp.length > 0) {
      <div formArrayName="kostenExtraGezinshulp">
        @for(item of kostenExtraGezinshulp.controls; track item; let i = $index) {
           <div  [formGroupName]="i" class="row" style="--bs-gutter-x: 0.5rem;">
          <snelstart-ui-text-form-control [label]="i === 0 ? 'Kosten extra gezinshulp' : ''"
                                          class="col-auto custom-input-250"
                                          formControlName="omschrijving"
                                          id="omschrijving"
          >

          </snelstart-ui-text-form-control>
          <snelstart-ui-number-form-control [decimals]="0"
                                            [label]="i === 0 ? 'Kosten' : ''"
                                            [required]=true
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="bedrag"
                                            id="bedrag"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
          <snelstart-ui-button (click)="verwijderRij(i)"
                               [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                               icon="trash"
                               iconType="light"
                               id="buttonDeleteKosten"
                               size="medium"
                               type="secondary"
          >
          </snelstart-ui-button>
        </div>
        }
      </div>
    }
  </form>

  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus"
                       type="link">Kosten extra gezinshulp
  </snelstart-ui-button>
}



